import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel'

Vue.component('Carousel', Carousel)
Vue.component('Slide', Slide)
